import transformSize from './transform-size'
import Logger from '../appl/logger'

function toApsSlot(slot: SlotDefinition): ApsSlot {
    return {
        slotID: slot.id,
        slotName: slot.name,
        sizes: transformSize(slot.size),
    }
}

function initApstag(apsConfig: ApsConfig) {
    /* tslint:disable:no-any */
    const que = (c: string, r: any[]) => window.apstag._Q.push([c, r])
    /* tslint:enable:no-any */
    window.apstag = window.apstag || {
        _Q: [],
        init: (config: ApsConfig) => que('i', [config]),
        fetchBids: (options: ApsFetchOption, callback: Command) => que('f', [options, callback]),
        setDisplayBids: () => void 0,
    }
    apsConfig.adServer = apsConfig.adServer || 'googletag'
    window.apstag.init(apsConfig)
}

/**
 * Amazon Publisher Service (APS) を利用した入札サービス実装クラス。
 */
export default class ApsBidderService implements BidderService {
    public static readonly NAME = 'APS'
    public readonly name = ApsBidderService.NAME
    public readonly apsSlots: Dict<ApsSlot> = {}

    constructor(config: HeaderBiddingConfig) {
        if (!config.apsConfig) {
            throw new Error('apsConfig が定義されていません')
        }
        initApstag(config.apsConfig)
    }

    /**
     * @override
     */
    public addSlot(...slots: SlotDefinition[]) {
        slots.filter(slot => slot.useAps).forEach(slot => this.addApsSlot(slot))
    }

    /**
     * @override
     */
    public requestBids(slots: SlotDefinition[], callback: Command) {
        const apsSlots = this.getApsSlots(slots)
        if (apsSlots.length < 1) {
            Logger.warn('APS 広告枠 がないため APS での入札は行いません', slots)
            callback()
            return
        }
        Logger.debug('APS 広告枠の入札を開始します', apsSlots)
        Logger.time('APS 広告入札リクエスト')
        window.apstag.fetchBids({ slots: apsSlots }, () => {
            Logger.timeEnd('APS 広告入札リクエスト')
            callback()
        })
    }

    public preRenderAds(_slots: SlotDefinition[]) {
        window.apstag.setDisplayBids()
    }

    private addApsSlot(slot: SlotDefinition) {
        this.apsSlots[slot.id] = toApsSlot(slot)
        Logger.debug(`APS 広告枠 [${slot.id}]`, this.apsSlots[slot.id])
    }

    private getApsSlots(slots: SlotDefinition[]) {
        return slots
            .map(slot => slot.id)
            .filter(id => id in this.apsSlots)
            .map(id => this.apsSlots[id])
    }
}
